import React, { Component } from 'react';
import { connect } from "react-redux";

import i18n from '../../i18n';
import EUFXPBannerEn from './EUFXPBannerEn';
import EUFXPBannerFr from './EUFXPBannerFr';

class EUDefaultBanner extends Component {
    constructor(props) {
        super(props);

        this.state = {
            windowWidth: window.innerWidth
        };

        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize() {
        this.setState({windowWidth: window.innerWidth})
    }

    render() {
        return (
            i18n.language === "fr" ? <EUFXPBannerFr /> : <EUFXPBannerEn />

            // <div className="eu-mainsection-banner">
            //     <div className="eu-mainsection-banner-content">
            //         <h1><Trans>Welcome to the</Trans> {this.props.settings.server_email_name === "Audi Sport Demo Pool" ? <> Audi Sport Demo Pool</>: <> DigitalVMS</>}!</h1>
            //         {
            //             this.props.settings.server_email_name == "Audi Sport Demo Pool" ?   
            //                 <>
            //                     <p><Trans>Exclusive Audi Sport Demo Pool vehicles are now available</Trans>.</p>
            //                 </>
            //             :
            //                 <>
            //                     <p><Trans>It is the ultimate resource to manage bookings from various fleets</Trans>.</p>
            //                 </>
            //         }
            //     </div>
            // </div>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    settings: store.settings
});

export default connect(mapStateToProps)(EUDefaultBanner);